import { Label } from "layout/typography/Label";
import { Checkbox } from "primereact/checkbox";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Title = styled.h3`
  margin-bottom: 10px;
  margin-left: 9px;
`;

export function PartialPayments() {
  const { control } = useFormContext<any>();

  return (
    <>
      <Title>Partial Payments</Title>
      <div className="flex flex-wrap w-100 mt-4 mb-4">
        <div className="field-checkbox col-12">
          <Label htmlFor="partialPaymentsEnabled">
            Partial Payments Enabled
          </Label>
          <Controller
            name="partialPaymentsEnabled"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Checkbox className="ml-3" onChange={onChange} checked={value} />
            )}
          />
        </div>
      </div>
    </>
  );
}
